import { render, staticRenderFns } from "./TenantSettingLayout.vue?vue&type=template&id=2fc9b712&scoped=true"
import script from "./TenantSettingLayout.vue?vue&type=script&lang=js"
export * from "./TenantSettingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc9b712",
  null
  
)

export default component.exports